import { Tv } from "lucide-react";

export default function NoStreamingCard() {
  return (
    <div className="mb-6">
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm backdrop-blur dark:border-gray-800 dark:bg-gray-900">

        <div className="p-0">
          
          {/* Video Container */}
          <div className="aspect-video flex items-center justify-center bg-gray-100 dark:bg-gray-800">

            <div className="text-center">

              <Tv className="mx-auto mb-3 h-12 w-12 text-gray-400 opacity-60" />

              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                No streaming servers available
              </p>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}